import React, { FC } from "react";
import propTypes from "prop-types";
import {
    FiHome,
    FiClock
} from 'react-icons/fi';

import { AssetLocation } from "../../../../logic/api";

import styles from "./styles";

import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import { locationPathTextToFriendly } from "../../../../utility/utils";
import { useDate } from "../../../../utility/useDate";
import { useTranslation } from "react-i18next";

const VehicleAuditDueListItem: FC<{ item: AssetLocation, onClick?: () => void }> = (props) => {
    const border = styles.border
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();

    return <div style={{ ...styles.listItem, ...border, cursor: "default" }} onClick={() => {
        if (props.onClick != null) {
            props.onClick();
        }
    }}>
        <div style={{ position: "absolute", textAlign: "center", width: 120, left: -67, bottom: 0, height: 15, top: 30, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", color: "white", transform: "rotate(270deg)" }}>
            <span>{t("lists.auditDue")}</span>
        </div>
        <div style={styles.listItemFlex}>
            <ListViewItemCard
                icon={<FiClock style={styles.icon} />}
                subText={toFormattedDateTimeString(new Date(props.item.auditDueDate))}
                text={t("locations.due")}
            />
            <ListViewItemCard
                icon={<FiHome style={styles.icon} />}
                text={props.item.name}
                subText={locationPathTextToFriendly(props.item.pathText)}
            />
        </div>
    </div>
}


VehicleAuditDueListItem.propTypes = {
    item: propTypes.any.isRequired,
    onClick: propTypes.func
};


export default VehicleAuditDueListItem;
